const getSxAttributes = (theme, sx) => {
  if (typeof sx === 'function') {
    return sx(theme);
  }

  return sx;
};

export default getSxAttributes;
